(function () {
  'use strict'

  var PARAM = 'fc_v'
  var VERSION = '1'

  function qs(root, sel) {
    return root.querySelector(sel)
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel))
  }

  function num(value, fallback) {
    var n = parseFloat(value)
    return isFinite(n) ? n : fallback
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value))
  }

  function fmt(value, digits) {
    if (!isFinite(value)) return 'n/a'
    var n = Number(value)
    var d = digits == null ? 1 : digits
    return n.toFixed(d)
  }

  function readSpecs(root) {
    var node = qs(root, '[data-fc-specs]')
    if (!node) return null
    try {
      return JSON.parse(node.textContent)
    } catch (err) {
      return null
    }
  }

  function deviceById(specs, id) {
    var list = specs.devices || []
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i]
    }
    return list[0] || null
  }

  function batteryCount(mode) {
    return mode === 'single' ? 1 : 2
  }

  function baseKg(specs, system, batteries) {
    var empty = specs.empty_kg[system] || specs.empty_kg.winch
    return empty + specs.battery_kg * batteries
  }

  function djiPayloadMax(specs, batteries) {
    return batteries === 1 ? specs.payload_max_kg.single : specs.payload_max_kg.dual
  }

  function deviceAllowed(device, system, battery) {
    if (!device) return false
    var systems = device.systems || ['winch', 'lift']
    var bats = device.batteries || ['single', 'dual']
    return systems.indexOf(system) !== -1 && bats.indexOf(battery) !== -1
  }

  function maxCargoKg(specs, system, battery, device, tare, mtow) {
    var batteries = batteryCount(battery)
    var base = baseKg(specs, system, batteries)
    var rated = djiPayloadMax(specs, batteries)
    var room = mtow - base - tare
    var ratedLeft = rated - tare
    var deviceMax = device && device.cargo_max_kg != null ? device.cargo_max_kg : rated
    return Math.max(0, Math.min(ratedLeft, room, deviceMax))
  }

  function flightMinutes(specs, tow, batteries) {
    var tRef = batteries === 1 ? specs.flight_min.single : specs.flight_min.dual
    var ratio = specs.ref_tow_kg / Math.max(tow, 1)
    var exp = specs.endurance_exponent == null ? 0.5 : specs.endurance_exponent
    var t = tRef * Math.pow(ratio, exp)
    var cap = tRef * (specs.endurance_cap_factor || 1.7)
    return Math.min(t, cap)
  }

  function rangeCapKm(specs, tow, batteries, speed, usableMin) {
    var published = batteries === 1 ? specs.range_km.single : specs.range_km.dual
    var tRef = batteries === 1 ? specs.flight_min.single : specs.flight_min.dual
    var t = flightMinutes(specs, tow, batteries)
    var scaled = published * (t / tRef)
    var kinematic = (usableMin * 60 * speed) / 1000
    return Math.min(scaled, kinematic)
  }

  function statusFor(result) {
    if (result.overMtow || result.overPayload || result.overDevice || result.overEnergy) {
      return {
        key: 'out',
        label: 'Outside published limits',
        detail: 'Ideal-conditions estimate only. Not a go/no-go and not a CASA approval.'
      }
    }
    if (result.tight) {
      return {
        key: 'tight',
        label: 'Tight on published limits',
        detail: 'Ideal conditions, sea level, no wind. Site weather still decides the job.'
      }
    }
    return {
      key: 'ok',
      label: 'Within published limits',
        detail: 'Ideal conditions at sea level. First-pass scope, not a quote.'
    }
  }

  function runCompute(specs, state) {
    var batteries = batteryCount(state.battery)
    var device = deviceById(specs, state.device)
    var tare = Math.max(0, num(state.tare, (device && device.tare_kg) || 0))
    var mtow = specs.mtow_kg.australia
    var base = baseKg(specs, state.system, batteries)
    var cargoMax = maxCargoKg(specs, state.system, state.battery, device, tare, mtow)
    var rated = djiPayloadMax(specs, batteries)
    var sliderMax = device && device.cargo_max_kg != null ? device.cargo_max_kg : rated
    sliderMax = Math.max(sliderMax, 1)
    var cargo = clamp(num(state.cargo, 0), 0, sliderMax)
    var payload = tare + cargo
    var tow = base + payload
    var reserve = clamp(num(state.reserve, 15), 0, 40) / 100
    var speed = clamp(num(state.speed, specs.default_speed_ms), 3, specs.max_speed_ms)
    var hoverSec = Math.max(0, num(state.hover, 0))
    var winchM = state.system === 'winch' ? clamp(num(state.winch, 0), 0, specs.winch.cable_m) : 0
    var winchSec = 0
    if (winchM > 0 && specs.winch.retract_ms) {
      winchSec = (2 * winchM) / specs.winch.retract_ms
    }
    var tMin = flightMinutes(specs, Math.max(tow, 1), batteries)
    var usableMin = tMin * (1 - reserve)
    var hoverMin = (hoverSec + winchSec) / 60
    var legs = state.leg === 'round' ? 2 : 1
    var distance = Math.max(0, num(state.distance, 0))
    var travelMin = speed > 0 ? (distance * 1000 * legs) / speed / 60 : 0
    var missionMin = travelMin + hoverMin
    var usage = usableMin > 0 ? (missionMin / usableMin) * 100 : 999
    var maxOneWay = Math.max(0, rangeCapKm(specs, tow, batteries, speed, Math.max(usableMin - hoverMin, 0)))
    var maxRound = maxOneWay / 2
    var overMtow = tow > mtow + 0.05
    var overDjiMtow = tow > specs.mtow_kg.dji + 0.05
    var overPayload = payload > rated + 0.05
    var overDevice = device && device.cargo_max_kg != null && cargo > device.cargo_max_kg + 0.05
    var overEnergy = usage > 100.05
    var tight = !overMtow && !overPayload && !overEnergy && (usage >= 80 || mtow - tow < 10)
    var singleCaution = state.battery === 'single'
    var margin = mtow - tow
    var result = {
      device: device,
      tare: tare,
      cargo: cargo,
      cargoMax: cargoMax,
      sliderMax: sliderMax,
      payload: payload,
      base: base,
      tow: tow,
      mtow: mtow,
      mtowDji: specs.mtow_kg.dji,
      rated: rated,
      margin: margin,
      tMin: tMin,
      usableMin: usableMin,
      missionMin: missionMin,
      travelMin: travelMin,
      hoverMin: hoverMin,
      usage: usage,
      speed: speed,
      maxOneWay: maxOneWay,
      maxRound: maxRound,
      overMtow: overMtow,
      overDjiMtow: overDjiMtow,
      overPayload: overPayload,
      overDevice: overDevice,
      overEnergy: overEnergy,
      tight: tight,
      singleCaution: singleCaution,
      tRef: batteries === 1 ? specs.flight_min.single : specs.flight_min.dual,
      rangeRef: batteries === 1 ? specs.range_km.single : specs.range_km.dual
    }
    result.status = statusFor(result)
    return result
  }

  function readState(root) {
    return {
      system: qs(root, '[data-fc-system][aria-pressed="true"]')
        ? qs(root, '[data-fc-system][aria-pressed="true"]').getAttribute('data-fc-system')
        : 'winch',
      battery: qs(root, '[data-fc-battery][aria-pressed="true"]')
        ? qs(root, '[data-fc-battery][aria-pressed="true"]').getAttribute('data-fc-battery')
        : 'dual',
      device: qs(root, '[data-fc-device][aria-pressed="true"]')
        ? qs(root, '[data-fc-device][aria-pressed="true"]').getAttribute('data-fc-device')
        : 'oem',
      cargo: qs(root, '[data-fc-cargo]').value,
      distance: qs(root, '[data-fc-distance]').value,
      speed: qs(root, '[data-fc-speed]').value,
      hover: qs(root, '[data-fc-hover]').value,
      reserve: qs(root, '[data-fc-reserve]').value,
      winch: qs(root, '[data-fc-winch]') ? qs(root, '[data-fc-winch]').value : 0,
      tare: qs(root, '[data-fc-tare]') ? qs(root, '[data-fc-tare]').value : 0,
      leg: qs(root, '[data-fc-leg][aria-pressed="true"]')
        ? qs(root, '[data-fc-leg][aria-pressed="true"]').getAttribute('data-fc-leg')
        : 'one'
    }
  }

  function setPressed(buttons, value, attr) {
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute(attr) === value ? 'true' : 'false')
    })
  }

  function writeUrl(state) {
    if (!window.history || !window.history.replaceState) return
    var params = new URLSearchParams(window.location.search)
    params.set(PARAM, VERSION)
    params.set('fc_sys', state.system)
    params.set('fc_bat', state.battery)
    params.set('fc_dev', state.device)
    params.set('fc_kg', String(state.cargo))
    params.set('fc_km', String(state.distance))
    params.set('fc_leg', state.leg)
    params.set('fc_spd', String(state.speed))
    params.set('fc_rsv', String(state.reserve))
    params.set('fc_hov', String(state.hover))
    if (state.system === 'winch') params.set('fc_win', String(state.winch))
    else params.delete('fc_win')
    if (state.device === 'custom') params.set('fc_tare', String(state.tare))
    else params.delete('fc_tare')
    var url = window.location.pathname + '?' + params.toString() + window.location.hash
    window.history.replaceState(null, '', url)
  }

  function applyUrl(root, specs) {
    var params = new URLSearchParams(window.location.search)
    if (params.get(PARAM) !== VERSION) return
    var sys = params.get('fc_sys')
    var bat = params.get('fc_bat')
    var dev = params.get('fc_dev')
    var aliases = {
      'byt-wb100-80': 'byt-wb100',
      'byt-wb100-180': 'byt-wb100'
    }
    if (aliases[dev]) dev = aliases[dev]
    var leg = params.get('fc_leg')
    if (sys === 'winch' || sys === 'lift') setPressed(qsa(root, '[data-fc-system]'), sys, 'data-fc-system')
    if (bat === 'single' || bat === 'dual') setPressed(qsa(root, '[data-fc-battery]'), bat, 'data-fc-battery')
    if (dev && deviceById(specs, dev)) setPressed(qsa(root, '[data-fc-device]'), dev, 'data-fc-device')
    if (leg === 'one' || leg === 'round') setPressed(qsa(root, '[data-fc-leg]'), leg, 'data-fc-leg')
    var device = deviceById(specs, qs(root, '[data-fc-device][aria-pressed="true"]')
      ? qs(root, '[data-fc-device][aria-pressed="true"]').getAttribute('data-fc-device')
      : 'oem')
    var batteries = batteryCount(qs(root, '[data-fc-battery][aria-pressed="true"]')
      ? qs(root, '[data-fc-battery][aria-pressed="true"]').getAttribute('data-fc-battery')
      : 'dual')
    var rated = djiPayloadMax(specs, batteries)
    var sliderMax = device && device.cargo_max_kg != null ? device.cargo_max_kg : rated
    var cargoEl = qs(root, '[data-fc-cargo]')
    if (cargoEl) cargoEl.max = String(Math.max(sliderMax, 1))
    function fill(sel, key) {
      var el = qs(root, sel)
      if (el && params.has(key)) el.value = params.get(key)
    }
    fill('[data-fc-cargo]', 'fc_kg')
    fill('[data-fc-distance]', 'fc_km')
    fill('[data-fc-speed]', 'fc_spd')
    fill('[data-fc-reserve]', 'fc_rsv')
    fill('[data-fc-hover]', 'fc_hov')
    fill('[data-fc-winch]', 'fc_win')
    fill('[data-fc-tare]', 'fc_tare')
  }

  function render(root, specs) {
    var state = readState(root)
    var device = deviceById(specs, state.device)
    if (device && !deviceAllowed(device, state.system, state.battery)) {
      setPressed(qsa(root, '[data-fc-device]'), 'oem', 'data-fc-device')
      state = readState(root)
      device = deviceById(specs, state.device)
    }

    qsa(root, '[data-fc-device]').forEach(function (btn) {
      var id = btn.getAttribute('data-fc-device')
      var d = deviceById(specs, id)
      var ok = deviceAllowed(d, state.system, state.battery)
      btn.disabled = !ok
      btn.classList.toggle('is-disabled', !ok)
    })

    var customWrap = qs(root, '[data-fc-custom]')
    if (customWrap) customWrap.hidden = state.device !== 'custom'

    var winchWrap = qs(root, '[data-fc-winch-wrap]')
    if (winchWrap) winchWrap.hidden = state.system !== 'winch'

    var oemBtns = qsa(root, '[data-fc-device="oem"] .fc__device-role')
    oemBtns.forEach(function (el) {
      el.textContent = state.system === 'winch' ? 'Flagship winch hook' : 'Lifting sling'
    })

    var tareInput = qs(root, '[data-fc-tare]')
    if (state.device !== 'custom' && device && tareInput) {
      tareInput.value = device.tare_kg || 0
    }
    if (state.device === 'custom' && tareInput && !tareInput.value) tareInput.value = '0'

    state = readState(root)
    var result = runCompute(specs, state)

    var cargo = qs(root, '[data-fc-cargo]')
    var sliderMax = Math.max(1, Math.round((result.sliderMax || result.rated) * 10) / 10)
    cargo.max = String(sliderMax)
    if (num(cargo.value, 0) > sliderMax) cargo.value = String(sliderMax)
    state.cargo = cargo.value
    result = runCompute(specs, state)

    var dist = qs(root, '[data-fc-distance]')
    var distMax = Math.max(0.5, result.rangeRef)
    dist.max = String(distMax)
    var cargoUnit = device && device.cargo_unit === 'L' ? ' L' : ' kg'
    qs(root, '[data-fc-cargo-val]').textContent = fmt(num(cargo.value, 0), 0) + cargoUnit
    qs(root, '[data-fc-cargo-max]').textContent = 'About ' + fmt(result.cargoMax, 1) + ' kg still fits Australian 150 kg MTOW'
    qs(root, '[data-fc-distance-val]').textContent = fmt(num(dist.value, 0), 1) + ' km'
    qs(root, '[data-fc-speed-val]').textContent = fmt(num(qs(root, '[data-fc-speed]').value, 0), 0) + ' m/s'
    qs(root, '[data-fc-hover-val]').textContent = fmt(num(qs(root, '[data-fc-hover]').value, 0), 0) + ' s'
    qs(root, '[data-fc-reserve-val]').textContent = fmt(num(qs(root, '[data-fc-reserve]').value, 0), 0) + '%'
    var winchEl = qs(root, '[data-fc-winch]')
    if (winchEl) qs(root, '[data-fc-winch-val]').textContent = fmt(num(winchEl.value, 0), 0) + ' m'

    var unit = device && device.cargo_unit === 'L' ? 'L' : 'kg'
    var cargoLabel = qs(root, '[data-fc-cargo-label]')
    if (cargoLabel) cargoLabel.textContent = unit === 'L' ? 'Water / load' : 'Cargo mass'

    qs(root, '[data-fc-tow]').textContent = fmt(result.tow, 1) + ' kg'
    qs(root, '[data-fc-margin]').textContent = (result.margin >= 0 ? '+' : '') + fmt(result.margin, 1) + ' kg'
    qs(root, '[data-fc-base]').textContent = fmt(result.base, 1) + ' kg'
    qs(root, '[data-fc-payload]').textContent = fmt(result.payload, 1) + ' kg'
    qs(root, '[data-fc-rated]').textContent = fmt(result.rated, 0) + ' kg'
    qs(root, '[data-fc-flight]').textContent = fmt(result.tMin, 1) + ' min'
    qs(root, '[data-fc-usable]').textContent = fmt(result.usableMin, 1) + ' min'
    qs(root, '[data-fc-mission]').textContent = fmt(result.missionMin, 1) + ' min'
    qs(root, '[data-fc-usage]').textContent = fmt(result.usage, 0) + '%'
    qs(root, '[data-fc-oneway]').textContent = fmt(result.maxOneWay, 1) + ' km'
    qs(root, '[data-fc-round]').textContent = fmt(result.maxRound, 1) + ' km'

    var bar = qs(root, '[data-fc-usage-bar]')
    if (bar) bar.style.width = clamp(result.usage, 0, 100) + '%'

    var status = qs(root, '[data-fc-status]')
    status.setAttribute('data-fc-tone', result.status.key)
    qs(root, '[data-fc-status-label]').textContent = result.status.label
    qs(root, '[data-fc-status-detail]').textContent = result.status.detail

    var flags = []
    if (result.overMtow) flags.push('Takeoff is over the Australian 150 kg cap.')
    if (result.overDjiMtow) flags.push('Takeoff is also over DJI 170 kg spec.')
    if (result.overPayload) flags.push('Hung mass is over the DJI payload rating.')
    if (result.overDevice) flags.push('Load is over this device rating.')
    if (result.overEnergy) flags.push('Mission time is over usable endurance after reserve.')
    if (result.singleCaution) flags.push('DJI lists single battery as emergency use.')
    if (device && device.tare_unknown) flags.push('Device tare is not published. Weigh it on the quote.')
    var flagBox = qs(root, '[data-fc-flags]')
    flagBox.hidden = flags.length === 0
    flagBox.innerHTML = flags.map(function (line) {
      return '<li>' + line + '</li>'
    }).join('')

    var note = qs(root, '[data-fc-device-note]')
    if (note) note.textContent = device && device.note ? device.note : ''

    root.classList.toggle('is-out', result.status.key === 'out')
    root.classList.toggle('is-tight', result.status.key === 'tight')

    writeUrl(readState(root))
  }

  function bind(root, specs) {
    applyUrl(root, specs)

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-fc-system], [data-fc-battery], [data-fc-leg], [data-fc-device]')
      if (!btn || !root.contains(btn) || btn.disabled) return
      event.preventDefault()
      if (btn.hasAttribute('data-fc-system')) setPressed(qsa(root, '[data-fc-system]'), btn.getAttribute('data-fc-system'), 'data-fc-system')
      if (btn.hasAttribute('data-fc-battery')) setPressed(qsa(root, '[data-fc-battery]'), btn.getAttribute('data-fc-battery'), 'data-fc-battery')
      if (btn.hasAttribute('data-fc-leg')) setPressed(qsa(root, '[data-fc-leg]'), btn.getAttribute('data-fc-leg'), 'data-fc-leg')
      if (btn.hasAttribute('data-fc-device')) setPressed(qsa(root, '[data-fc-device]'), btn.getAttribute('data-fc-device'), 'data-fc-device')
      render(root, specs)
    })

    root.addEventListener('input', function (event) {
      if (!event.target.closest('[data-fc-cargo], [data-fc-distance], [data-fc-speed], [data-fc-hover], [data-fc-reserve], [data-fc-winch], [data-fc-tare]')) return
      render(root, specs)
    })

    var copyBtn = qs(root, '[data-fc-copy]')
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = window.location.href
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            copyBtn.textContent = 'Link copied'
            setTimeout(function () { copyBtn.textContent = 'Copy link' }, 1600)
          })
        }
      })
    }

    render(root, specs)
  }

  function boot() {
    qsa(document, '[data-mm-flycart]').forEach(function (root) {
      if (root.getAttribute('data-fc-ready')) return
      var specs = readSpecs(root)
      if (!specs) return
      root.setAttribute('data-fc-ready', '1')
      bind(root, specs)
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()
})()
